import { createApp } from 'vue'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import App from './App.vue'
// import App from './components/organisms/HomePage.vue'

import * as labs from 'vuetify/labs/components'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import 'vuetify/dist/vuetify.min.css';
import router from './router'

const vuetify = createVuetify({
  components: {
    ...labs,
    ...components
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    }
  },
  directives,
})

const app = createApp(App)

app.use(vuetify);
app.use(router);

app.mount('#app')
